export default "https://dakcheck.solease.nl/static/media/plus.81605b82.svg";